import React from "react";
import Schuif from "../../doors/schuif";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SingleSchuifProps extends ConfigurationProps {}

const SingleSchuif: React.FC<SingleSchuifProps> = ({
  materials,
  position,
  scale,
  doorSettings,
}: SingleSchuifProps) => {
  const { sceneStaanderPosition } = useConfigurationOptionsContext();

  return (
    <group scale={scale}>
      <Schuif
        materials={materials}
        position={position}
        frameSettings={doorSettings?.main?.frameSettings}
        railSettings={doorSettings?.main?.railSettings}
        verticalBeamPosition={sceneStaanderPosition}
      />
    </group>
  );
};

export default SingleSchuif;
